import React, { useState, useEffect, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Form, Col } from 'react-bootstrap';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import If from '../../../../components/If';
import Loading from '../../../../components/Loading';
import Button from '../../../../components/Button';
import EditButton from '../../../../components/EditButton';
import SearchEmpty from '../../../../components/SearchEmpty';
import api from '../../../../services/api';
import { ApplicantResults } from '../../../../models/models';
import { statusToText } from '../../../../functions/formatStatus';
import '../../styles_list.css';

export default function Applicant ()
{
	const history = useHistory();
	const [applicants, setApplicants] = useState<Array<ApplicantResults>>([]);
	const [loading, setLoading] = useState<boolean>(true);
	const [loadingSearch, setLoadingSearch] = useState<boolean>(false);
	const [error, setError] = useState<boolean>(false);
	const [emptySearch, setEmptySearch] = useState<boolean>(false);

	const { register, handleSubmit, getValues } = useForm({
		defaultValues: { name: '', active: true },
	})

	useEffect(() => {
		const getApplicants = async () => {
			try {
				const { data } = await api.get<ApplicantResults[]>(`api/v1/cultivares/Requerente/obterporfiltro?Ativo=${getValues('active')}`);

				setApplicants(data);
			} catch (error:any) {
				setError(true);
			}
			setLoading(false);
		}
		getApplicants();
	}, [getValues])

	const search = async () => {
		setError(false);
		setLoadingSearch(true);

		try {
			const { data } = await api.get<ApplicantResults[]>(`api/v1/cultivares/Requerente/obterporfiltro?Ativo=${getValues('active')}&Nome=${getValues('name')}`);

			if (data.length) {
				setApplicants(data);
				setEmptySearch(false);
			} else {
				setEmptySearch(true);
			}
		} catch (error:any) {
			setError(true);
		}
		setLoadingSearch(false);
	}

	const actions = ({ data }: any) => (
		<Fragment>
			<EditButton
				onClick={() => history.push({
					pathname: '/editar/requerente',
					state: {
						id: data.id
					}
				})}
			/>
		</Fragment>
	);

	return <div className="container-custom-search">
		<div className="top-content">
			<h3>Consulta de requerente</h3>
		</div>
		<div className="row-buttons">
			<Button
				onClick={() => history.push('/cadastrar/requerente')}
				contained
				title="Adicionar"
				type="button"
			/>
		</div>
		<br />
		<Form onSubmit={handleSubmit(search)}>
			<Form.Row className="row-custom">
				<Form.Group as={Col} md={8}>
					<Form.Label>Nome do requerente</Form.Label>
					<Form.Control
						ref={register}
						name="name"
						maxLength={100}
						autoComplete="off"
					/>
				</Form.Group>
				<Form.Group>
					<Form.Label />
					<Form.Check
						type="checkbox"
						ref={register}
						name="active"
						label="Ativos"
					/>
				</Form.Group>
				<span className="filter-btn">
					<Button
						title="Buscar"
						type="submit"
						contained
						isLoading={loadingSearch}
					/>
				</span>
			</Form.Row>
		</Form>
		<If condition={emptySearch}>
			<div className="div-empty">
				<SearchEmpty />
			</div>
		</If>
		<If condition={!loading && !error && !emptySearch && applicants.length}>
			<div className="search-content">
				<div className="ag-theme-alpine" style={{height: "70vh", width: '100%'}}>
					<AgGridReact
						rowData={applicants}
						defaultColDef={{flex: 1, sortable: true, resizable:true }}
						pagination
						paginationPageSize={10}
						frameworkComponents={{actions: actions}}
					>
						<AgGridColumn
							headerName='Nome do Requerente'
							field="nome"
							cellStyle={{justifyContent: 'left'}}
						/>
						<AgGridColumn
							headerName='Email do Requerente'
							field="email"
							cellStyle={{justifyContent: 'left'}}
						/>
						<AgGridColumn
							headerName="Status"
							field="ativo"
							valueFormatter={({ data }: any) => statusToText(data.ativo)}
							maxWidth={130}
						/>
						<AgGridColumn
							field='Ações'
							cellRenderer='actions'
							maxWidth={130}
						/>
					</AgGridReact>
				</div>
			</div>
		</If>
		<If condition={loading}>
			<div className="loading-container">
				<Loading />
			</div>
		</If>
	</div>;
}